<template>
  <div>
    <q-card>
      <q-card-section class="q-pa-none">
        <div class="row" v-if="nearestLocations">
          <div class="col-12 mt-0 pt-0" style="height: 200px">
            <datatable
              :filter="filter"
              :flat="true"
              :data="nearestLocations"
              :columns="columns"
              :externalFilter="gridFilter"
              dense
              @rowSelected="handleSingleClick"
            />
          </div>
        </div>
      </q-card-section>
    </q-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import datatable from "@/components/datatable/datatable.vue";
import moment from "moment";

// import { Notify } from "quasar";

export default {
  props: {
    selectedSurveys: {
      type: Array,
    },
  },
  components: {
    datatable,
  },
  computed: {
    ...mapGetters([
      "currentUser",
      "selectedRowData",
      "aGGridActionMenu",
      "nearestLocations",
      "nearestLocationsLoading",
    ]),
    filter() {
      return {
        selectedSurveys: this.selectedSurveys,
      };
    },
  },
  data: () => ({
    // data-table
    columns: [
      {
        name: "name",
        label: "Name",
        align: "left",
        field: "name",
        sortable: true,
      },
      {
        name: "date",
        label: "Date",
        align: "left",
        field: "date",
        format: (val) => (val != null ? moment(val).format("DD/MMM/YYYY") : ""),
        sortable: true,
      },
      {
        name: "distance",
        label: "Distance (km)",
        align: "left",
        field: "distance",
        format: (val) =>
          val != null
            ? `${Math.round((parseFloat(val) + Number.EPSILON) * 100) / 100}km`
            : "",
        sortable: true,
      },
    ],
    search: "",

    dataUploadLoading: false,
  }),
  beforeCreate() {
    // this.$store.dispatch("loadPastSurveys");
  },
  mounted() {},
  methods: {
    handleSingleClick(row) {
      // console.log(row);
      if (row.distance > 0.1) {
        row.toBeFlipped = true;
      }
      this.$emit("selectSurvey", row);
    },
    gridFilter(rows, terms, cols) {
      console.log(rows);
      if (rows) {
        return rows.filter((row) => {
          let selectedSurveyIds = [];
          terms.selectedSurveys.forEach((element) => {
            selectedSurveyIds.push(element.id);
          });
          return !selectedSurveyIds.includes(row.id);
        });
      } else {
        return [];
      }
    },
  },
};
</script>

<style scoped>
#depthCard:hover {
  background: #5cb3ff;
  color: white;
}
</style>
